import React from 'react';
import ReactSVG from 'react-svg';
import classnames from 'classnames';

const LandingPageSkeleton = () => {
  const pageCssBEM = 'landingPage';
  const classes = classnames( pageCssBEM, {
    [`${pageCssBEM}--skeleton`]: true
  });

  return (
    <div className={classes}>
      <ReactSVG src="/classpath/assets/images/loading.svg" />
    </div>
  );
};

export default LandingPageSkeleton;

